import { render, staticRenderFns } from "./CrftEditMain.vue?vue&type=template&id=1dc58977&scoped=true&"
import script from "./CrftEditMain.vue?vue&type=script&lang=js&"
export * from "./CrftEditMain.vue?vue&type=script&lang=js&"
import style0 from "./CrftEditMain.vue?vue&type=style&index=0&id=1dc58977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc58977",
  null
  
)

export default component.exports